module.exports = __webpack_public_path__ + "img/checklist.b7ebc949.svg";